import { render } from "./Usuario_Pago.vue?vue&type=template&id=0b909616"
import script from "./Usuario_Pago.vue?vue&type=script&lang=js"
export * from "./Usuario_Pago.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__